<template>
  <div class="about-introduce">
    <div class="container">
      <div class="about-subject">
        <span class="about-title">公司介绍</span>
        <span class="about-describe">
          <p>首个实现艺术墙“一体化”</p>
          <p>艺术浮雕+艺术彩绘+艺术涂料</p>
        </span>
      </div>
      <div class="about-content">
        <div class="about-text">
          懒精灵FREEGENIUS成立于2016年，<br>
          是长沙美家乐装饰材料旗下原创精品艺术涂料品牌。<br>
          懒精灵凭借多年行业经验，打通墙艺美学、涂料产品研发、涂料施工培训环节，<br>
          为消费者提供高品质、高性价比、新材料新技术的艺术涂料解决方案，<br>
          开拓千亿艺术墙艺市场。
        </div>

      </div>
      <div class="about-img">
        <img src="https://img.xnxx.mengcreate.com/LJL/about-diaosu.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
@height: 750px;
.about-introduce::before {
  min-width: 1200px;
  content: "";
  width: 100%;
  height: @height;
  position: absolute;
  z-index: -1;
  background: url(http://img.codefly.top/banner6.png) no-repeat;
  background-size: 100% 70%;
  background-position: center 0;
  filter: grayscale(100%) brightness(230%);
}
.about-introduce {
  min-height: 750px;
  overflow: hidden;

  .container {
    height: @height;
    padding: 6rem 0 0;
    position: relative;
    width: 1200px;
    .about-subject {
      width: 100%;
      height: 70%;
      color: #007455;
      .about-title {
        display: inline-block;
        font-weight: 500;
        padding: 0.2rem;
        border-bottom: 1px #007455 solid;
        margin-bottom: 3rem;
      }
      .about-describe {
        font-size: 1.3rem;
        p:nth-child(1) {
          font-size: 2rem;
          font-weight: 600;
        }
      }
    }
    .about-content {
      font-size: 1rem;
      line-height: 1.5rem;
    }
    .about-img {
      position: absolute;
      right: 0;
      bottom: 0;
      img {
        filter: grayscale(100%) brightness(100%);
      }
    }
  }
}
@media only screen and (max-width: 786px) {
  .about-introduce::before {
    min-width: auto;
    max-width: 786px;
    width: 100%;
  }
  .about-introduce {
    .container {
      max-width: 786px;
      width: 100%;
      padding: 6rem 20px 0;
      .about-img {
        display: none;
      }
    }
  }
}
</style>